import React, { useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";


// components
import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";


// actions
import { setFilter } from "../../../redux/actions/generalActions/listActions";
import { CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import {
    FL_CODE,
} from "../../../components/i18n/formLabels";

const ApplicativeFilters = props => {
    const { filter } = props.listProps

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))

        reset({
            code: '',
        });

        if(tmpFilter ){
            delete tmpFilter.code;
        }

        props.setFilter(tmpFilter);
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: filter?.code,
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = { ...data }


        props.setFilter(dataFilter);
    };

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_CODE }</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder={ FL_CODE }
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(ApplicativeFilters)